import React, { useEffect, useRef } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import qs from 'qs';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GlobalPopupConfirm, { GlobalPopupConfirmRef } from 'src/components/GlobalPopupConfirm';
import PopupService from 'src/utils/PopupService';
import GlobalBottomSheet, { GlobalBottomSheetRef } from 'src/components/GlobalBottomSheet';
import LoadingModal, { LoadingModalRef } from 'src/components/LoadingModal';
import LoadingService from 'src/utils/LoadingService';
import BottomSheetService from 'src/utils/BottomSheetService';

// Routes
import NoMatch from 'src/screens/NoMatch';
// import Login from 'src/screens/Login';
import Home from 'src/screens/Home';
import Card from 'src/screens/Card';
import Referral from 'src/screens/Referral';
import User from 'src/screens/User';
import InsuranceService from 'src/screens/InsuranceService';
import YourInfo from 'src/screens/YourInfo';
import InsuranceBenefit from 'src/screens/InsuranceBenefit';
import Voucher from 'src/screens/Cancer/Voucher';
import HealthQuestion from 'src/screens/HealthQuestion';
import ConfirmInfo from 'src/screens/ConfirmInfo';
import Commitment from 'src/screens/Commitment';
import Payment from 'src/screens/Payment';
import PaymentCancerSuccessNoMoney from 'src/screens/PaymentCancerSuccessNoMoney';
import ItemDetail from 'src/screens/ItemDetail';
import ProductList from 'src/screens/ProductList';
import NewsAndPromotion from 'src/screens/NewsAndPromotion';
import CancerInsurranceInfo from 'src/screens/CancerInsurranceInfo';
import SpaInsurranceInfo from 'src/screens/SpaInsurranceInfo';
import YourInfoSpa from 'src/screens/YourInfoSpa';
import CommitmentSpa from 'src/screens/CommitmentSpa';
import ConfirmInfoSpa from 'src/screens/ConfirmInfoSpa';
import TermAndCondition from 'src/screens/TermAndCondition';
// Fee
import FeeForm from 'src/screens/fee/FeeForm';
import FeeConfirm from 'src/screens/fee/FeeConfirm';
//BottomTab
// import BottomTabBar from 'src/components/BottomTabBar';
import HomeActive from 'src/assets/tab_home_active.svg';
import CardActive from 'src/assets/tab_credit_card_active.svg';
import AccountActive from 'src/assets/tab_account_active.svg';
import MoreActive from 'src/assets/tab_more_active.svg';

// Preload Image
// import { PreloadImage } from 'src/assets';
import UserInfoService from 'src/utils/UserInfoService';
import HomeSkeleton from 'src/components/HomeSkeleton';

import homeStore, { HomeStore } from 'src/stores/HomeStore';
import { observer } from 'mobx-react-lite';
import MyPolicy from './screens/MyPolicy';
import PolicyPayment from './screens/PolicyPayment';
import ListPolicy from './screens/ListPolicy';
import CancelPolicy from 'src/screens/CancelPolicy';
import CompleteCancel from 'src/screens/CancelPolicy/CompleteCancel';
import PeriodicPayment from 'src/screens/PeriodicPayment';
import TopUpPayment from 'src/screens/TopUpPayment';
import OtpCancelPolicy from 'src/screens/CancelPolicy/OtpCancelPolicy';
import SpecialOffers from './screens/SpecialOffers';
import SpecialOffersCampaign from './screens/SpecialOffersLocalAccountCampaign';
import { PATH } from './constants';
import { getLoginToken } from './utils';
import PaymentOnline from './screens/PaymentOnline';
import RegisterAutoPayment from './screens/RegisterAutoPayment';
import DetailAutoPayment from './screens/DetailAutoPayment';
import CancelRegister from './screens/CancelRegister';
import ConfirmRegisterAutoPayment from './screens/ConfirmRegisterAutoPayment';

// const HomeTabRouteObserver = observer(
//   ({ store }: HomeTabRouteObserverProps) => {
//     const location = useLocation();

//     useEffect(() => {
//       let queryUrl = location.search;
//       const queryParams = qs.parse(queryUrl, { ignoreQueryPrefix: true });
//       const loginToken = queryParams?.loginToken as string;
//       if (!UserInfoService.getLoginToken()) {
//         store.fetchLogin(loginToken);
//       } else {
//         store.setLogining(false);
//       }
//     }, [location, store]);

//     if (store.logining) {
//       return <HomeSkeleton />;
//     }

//     return (
//       <div>
//         <Switch>
//           {routes.map((route, index) => {
//             return (
//               <Route
//                 key={index}
//                 path={route.path}
//                 children={<route.main />}
//                 exact={route.exact}
//               />
//             );
//           })}
//         </Switch>
//         {/* <BottomTabBar /> */}
//       </div>
//     );
//   }
// );

// const HomeTabRoute = () => {
//   return <HomeTabRouteObserver store={homeStore} />;
// };

//  useEffect(() => {
//     let queryUrl = location.search;
//     const queryParams = qs.parse(queryUrl, { ignoreQueryPrefix: true });
//     const loginToken = queryParams?.loginToken as string;
//     if (!UserInfoService.getLoginToken()) {
//       store.fetchLogin(loginToken);
//     } else {
//       store.setLogining(false);
//     }
//   }, [location, store]);

//   if (store.logining) {
//     return <HomeSkeleton />;
//   }

interface AppRouteWithAuthObserverProps {
  store?: HomeStore;
  children?: React.ReactNode;
}

const AppRouteWithAuthObserver = observer(
  ({ children, store, ...rest }: AppRouteWithAuthObserverProps) => {
    const location = useLocation();
    useEffect(() => {
      let queryUrl = location.search;
      const queryParams = qs.parse(queryUrl, { ignoreQueryPrefix: true });
      const loginToken = (queryParams?.loginToken as string) || getLoginToken();
      if (!UserInfoService.getLoginToken()) {
        store.fetchLogin(loginToken);
      } else {
        store.setLogining(false);
      }
    }, [location, store]);

    if (store.logining) {
      return <HomeSkeleton />;
    }
    return <Route {...rest} render={({ location }) => children} />;
    // let { username } = useAuth();
    // return (
    //   <Route
    //     {...rest}
    //     render={({ location }) =>
    //       username ? (
    //         children
    //       ) : (
    //         <Redirect
    //           to={{
    //             pathname: "/login",
    //             state: { from: location },
    //           }}
    //         />
    //       )
    //     }
    //   />
    // );
  }
);
const AppRouteWithAuth = (props) => (
  <AppRouteWithAuthObserver store={homeStore} {...props} />
);

export const routes = [
  {
    path: '/',
    exact: true,
    main: () => <Home />,
    text: 'home',
    icon: HomeActive,
  },
  {
    path: '/card',
    main: () => <Card />,
    text: 'payment',
    icon: CardActive,
  },
  {
    path: '/referral',
    main: () => <Referral />,
    text: 'account',
    icon: AccountActive,
  },
  {
    path: '/user',
    main: () => <User />,
    text: 'view_more',
    icon: MoreActive,
  },
];

const HomeTabRoute = () => {
  return (
    <div>
      <Switch>
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              children={<route.main />}
              exact={route.exact}
            />
          );
        })}
      </Switch>
      {/* <BottomTabBar /> */}
    </div>
  );
};

function App() {
  PopupService.instance = useRef<GlobalPopupConfirmRef>(null);
  BottomSheetService.instance = useRef<GlobalBottomSheetRef>(null);
  LoadingService.instance = useRef<LoadingModalRef>(null);

  const _handleRNMessage = (message) => {
    alert('Message from RN: ' + JSON.stringify(message.data));
  };

  useEffect(() => {
    document.addEventListener('reactnative_message', _handleRNMessage);
    return () => {
      document.removeEventListener('reactnative_message', _handleRNMessage);
    };
  }, []);

  // const _renderPreloadImage = () => {
  //   return (
  //     <div className="w-0 h-0">
  //       {PreloadImage.map((item, index) => {
  //         return <img src={item} key={item} className="w-0 h-0" />;
  //       })}
  //     </div>
  //   );
  // };

  return (
    <div className="theme-default max-w-md mx-auto">
      <ToastContainer />

      <GlobalPopupConfirm ref={PopupService.instance} />
      <GlobalBottomSheet ref={BottomSheetService.instance} />
      <LoadingModal ref={LoadingService.instance} />
      <Router>
        <Switch>
          <AppRouteWithAuth path="/insurance_service">
            <InsuranceService />
          </AppRouteWithAuth>
          <AppRouteWithAuth path={["/buy-insurance/cancer/product-info", "/your_info"]}>
            <CancerInsurranceInfo />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/customer-info">
            <YourInfo />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/benefit-packages">
            <InsuranceBenefit />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/cancer/voucher">
            <Voucher />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/health-question">
            <HealthQuestion />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/confirm-customer-info">
            <ConfirmInfo />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/customer-commitment">
            <Commitment />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/term-and-condition">
            <TermAndCondition />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/confirm-payment">
            <Payment />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/buy-insurance/cancer/release-policy">
            <PaymentCancerSuccessNoMoney />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/item_detail">
            <ItemDetail />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/product_list">
            <ProductList />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/news_and_promotion">
            <NewsAndPromotion />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/spa_insurrance_info">
            <SpaInsurranceInfo />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/your_info_spa">
            <YourInfoSpa />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/commitment_spa">
            <CommitmentSpa />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/confirm_info_spa">
            <ConfirmInfoSpa />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={["/online-payment/form", "/fee/form"]}>
            <FeeForm />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/online-payment/confirm">
            <FeeConfirm />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/online-payment">
            <FeeForm />
          </AppRouteWithAuth>

          <AppRouteWithAuth path="/policy/search">
            <ListPolicy />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/policy/payment">
            <PolicyPayment />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/policy/complete-cancel">
            <CompleteCancel />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/policy/cancel/otp">
            <OtpCancelPolicy />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/policy/cancel">
            <CancelPolicy />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/policy/periodic-payment">
            <PeriodicPayment />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/policy/topup-payment">
            <TopUpPayment />
          </AppRouteWithAuth>
          <AppRouteWithAuth path="/my-policy">
            <MyPolicy />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={PATH.DETAIL_AUTO_PAYMENT}>
            <DetailAutoPayment />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={PATH.CANCEL_REGISTER}>
            <CancelRegister />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={PATH.CONFIRM_REGISTER_AUTO_PAYMENT}>
            <ConfirmRegisterAutoPayment />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={PATH.REGISTER_AUTO_PAYMENT}>
            <RegisterAutoPayment />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={PATH.PAYMENT_ONLINE}>
            <PaymentOnline />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={PATH.SPECIAL_OFFERS_CAMPAIGN}>
            <SpecialOffersCampaign />
          </AppRouteWithAuth>

          <AppRouteWithAuth path={PATH.SPECIAL_OFFERS}>
            <SpecialOffers />
          </AppRouteWithAuth>

          <AppRouteWithAuth path="/">
            <HomeTabRoute />
          </AppRouteWithAuth>
          <Route path="*">
            <NoMatch />
          </Route>
        </Switch>
      </Router>
      {/* {_renderPreloadImage()} */}
    </div>
  );
}

export default App;
